import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { rootGuard } from './core/auth/root.guard';
import { rootAdminGuard } from './core/auth/root-admin.guard';
import { tenantWorkspaceGuard } from './core/auth/tenant-workspace.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./landing/landing.page').then((m) => m.LandingPage),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    canActivate: [authGuard],
  },
  {
    path: 'workspace',
    loadComponent: () =>
      import('./tenant-workspace/tenant-workspace.page').then((m) => m.TenantWorkspacePage),
    canActivate: [authGuard, tenantWorkspaceGuard],
  },
  /** Ficha de socio: todos los bloques de formulario visibles para diseño y modelo de datos (no guarda). */
  {
    path: 'formularios',
    loadComponent: () =>
      import('./formularios-vista/formularios-vista.page').then((m) => m.FormulariosVistaPage),
    canActivate: [authGuard],
  },
  {
    path: 'view',
    redirectTo: 'view/help',
    pathMatch: 'full',
  },
  {
    path: 'view/:folder',
    loadComponent: () => import('./doc-view/doc-view.page').then((m) => m.DocViewPage),
    canActivate: [authGuard, rootGuard],
  },
  {
    path: 'view/:folder/:slug',
    loadComponent: () => import('./doc-view/doc-view.page').then((m) => m.DocViewPage),
    canActivate: [authGuard, rootGuard],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./admin/admin-shell/admin-shell-layout.component').then((m) => m.AdminShellLayoutComponent),
    canActivate: [authGuard, rootAdminGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./admin/admin-dashboard/admin-dashboard.page').then((m) => m.AdminDashboardPage),
        data: { adminTitle: 'Panel', hideToolbarTitle: true },
      },
      {
        path: 'monotributo-catalogo',
        loadComponent: () =>
          import('./admin/admin-monotributo-catalogo/admin-monotributo-catalogo.page').then(
            (m) => m.AdminMonotributoCatalogoPage
          ),
        data: { adminTitle: 'Monotributo ARCA', hideToolbarTitle: false },
      },
      {
        path: 'migracion-presupuesto',
        loadComponent: () =>
          import('./admin/admin-migracion-presupuesto/admin-migracion-presupuesto.page').then(
            (m) => m.AdminMigracionPresupuestoPage
          ),
        data: { adminTitle: 'Presupuesto migración', hideToolbarTitle: true },
      },
      {
        path: 'cooperativas',
        loadComponent: () =>
          import('./admin/cooperativas-management/cooperativas-management.page').then(
            (m) => m.CooperativasManagementPage
          ),
        data: { hideToolbarTitle: true },
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'activas' },
          {
            path: 'activas',
            loadComponent: () =>
              import('./admin/cooperativas-gestion/cooperativas-gestion.page').then(
                (m) => m.CooperativasGestionPage
              ),
            data: { hideToolbarTitle: true },
          },
          {
            path: 'catalogo',
            loadComponent: () =>
              import('./admin/cooperativas-catalogo/cooperativas-catalogo.page').then(
                (m) => m.CooperativasCatalogoPage
              ),
            data: { hideToolbarTitle: true },
          },
          {
            path: 'almacenamiento/:cooperativaId',
            loadComponent: () =>
              import('./admin/cooperativa-almacenamiento-config/cooperativa-almacenamiento-config.page').then(
                (m) => m.CooperativaAlmacenamientoConfigPage
              ),
            data: {
              adminTitle: 'Almacenamiento',
              hideToolbarTitle: false,
              storageConfigContext: 'admin',
            },
          },
        ],
      },
      { path: 'cooperativas/gestion', redirectTo: 'cooperativas/activas', pathMatch: 'full' },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
